import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "table-responsive mb-3"
}
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = {
  scope: "col",
  class: "text-end cell-header"
}
const _hoisted_5 = {
  scope: "col",
  class: "text-end cell-header"
}
const _hoisted_6 = {
  scope: "col",
  class: "text-end cell-header"
}
const _hoisted_7 = { scope: "row" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { colspan: "3" }
const _hoisted_16 = { class: "table mb-0" }
const _hoisted_17 = { scope: "row" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "text-end" }

import { ref, computed } from "vue";
import { formatter } from "@/shared/ts/formatter";
import { RetirementPlanResponse } from "@/guiide/ts/response/retirementPlanResponse";
import { RetirementPlanYear } from "@/guiide/ts/response/retirementPlanYear";
import { getMonthName } from "@/guiide/ts/utilities";
import { useStore } from "vuex";
import HelpText from "@/guiide/ts/helpText";
import LoadingSpinner from "@/shared/components/LoadingSpinner.vue";
import Help from "./Help.vue";

const abbreviatedPlanRowCount = 5;

export default /*@__PURE__*/_defineComponent({
  __name: 'PlanTable',
  props: {
    showFullTable: { type: Boolean, default: true },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const displayFullRetirementPlan = ref(false);
const store = useStore();
const retirementPlan = computed<RetirementPlanResponse>(() => store.state.plan);

const hasPlan = computed<boolean>(() => {
    return retirementPlan.value != null;
});

const retirementPlanYears = computed<Array<RetirementPlanYear>>(() => {
    if (!hasPlan.value) {
        return new Array<RetirementPlanYear>();
    }

    const itemCount = displayFullRetirementPlan.value
        ? 100
        : abbreviatedPlanRowCount;

    return retirementPlan.value.years.slice(0, itemCount);
});

function startYearText(year: number): string {
    return `${year}/${year + 1 - 2000}`;
}

function toggleShowMonthDetail(retirementPlanYear: RetirementPlanYear) {
    retirementPlanYear.displayMonthDetail = !retirementPlanYear.displayMonthDetail;
}

function toggleFullPlanDisplay() {
    displayFullRetirementPlan.value = !displayFullRetirementPlan.value;
}

__expose({
    toggleFullPlanDisplay
});


return (_ctx: any,_cache: any) => {
  return (!hasPlan.value)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "me-2" }, "Retrieving your plan...", -1)),
        _createVNode(LoadingSpinner)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("th", {
                scope: "col",
                class: "cell-header"
              }, "Year", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("th", {
                scope: "col",
                class: "text-end cell-header"
              }, "Take from pension pots", -1)),
              (__props.showFullTable)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[4] || (_cache[4] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-end cell-header"
                    }, "Take from savings pots", -1)),
                    _createElementVNode("th", _hoisted_4, [
                      _cache[1] || (_cache[1] = _createTextVNode(" Everything else you expect to get ")),
                      _createVNode(Help, {
                        title: "Everything else",
                        text: _unref(HelpText).planTableEverythingElse()
                      }, null, 8, ["text"])
                    ]),
                    _createElementVNode("th", _hoisted_5, [
                      _cache[2] || (_cache[2] = _createTextVNode(" Less tax you expect to pay ")),
                      _createVNode(Help, {
                        title: "Tax to pay",
                        text: _unref(HelpText).planTableTaxToPay()
                      }, null, 8, ["text"])
                    ]),
                    _createElementVNode("th", _hoisted_6, [
                      _cache[3] || (_cache[3] = _createTextVNode(" Total you expect to get after tax ")),
                      _createVNode(Help, {
                        title: "Total",
                        text: _unref(HelpText).planTableTotal()
                      }, null, 8, ["text"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _cache[7] || (_cache[7] = _createElementVNode("th", {
                scope: "col",
                class: "text-end cell-header"
              }, "Monthly", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(retirementPlanYears.value, (planYear) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: planYear.startYear
              }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(startYearText(planYear.startYear)), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formatter).formatCurrency(planYear.takeFromPensions)), 1),
                  (__props.showFullTable)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(formatter).formatCurrency(planYear.takeFromSavings)), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(formatter).formatCurrency(planYear.everythingElseExpectToGet)), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatter).formatCurrency(planYear.tax)), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formatter).formatCurrency(planYear.totalAfterTax)), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", {
                    class: "text-end",
                    onClick: ($event: any) => (toggleShowMonthDetail(planYear))
                  }, _toDisplayString(planYear.displayMonthDetail ? "Hide" : "Show"), 9, _hoisted_13)
                ]),
                (planYear.displayMonthDetail)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("div", null, [
                          _createElementVNode("table", _hoisted_16, [
                            _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                  scope: "col",
                                  class: ""
                                }, "Month"),
                                _createElementVNode("th", {
                                  scope: "col",
                                  class: "text-end"
                                }, " Take from Pension Pots "),
                                _createElementVNode("th", {
                                  scope: "col",
                                  class: "text-end"
                                }, " Take from Savings Pots ")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planYear.planMonths, (planMonth) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: `${planYear.startYear}-${planMonth.month}`
                                }, [
                                  _createElementVNode("th", _hoisted_17, _toDisplayString(_unref(getMonthName)(planMonth.month)), 1),
                                  _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatter).formatCurrency(
                                                                planMonth.takeFromPensions
                                                            )), 1),
                                  _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatter).formatCurrency(
                                                                planMonth.takeFromSavings
                                                            )), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ]))
}
}

})